module.exports = __webpack_public_path__ + "img/42f1b66.png";